import { Indicator, IndicatorGroup } from '@/components/survey/common/ui';
import common from '@/components/survey/common/ui/styles/common.module.scss';

export const SpecialRelationshipTitleIndicator = () => {
  return (
    <header className={common.flow_header}>
      <h1 className={common.flow_title}>직원 관계 확인</h1>
      <IndicatorGroup>
        <Indicator active>1</Indicator>
        <Indicator active={false}>2</Indicator>
        <Indicator active={false}>3</Indicator>
      </IndicatorGroup>
    </header>
  );
};
